<template>
  <div v-if="getSelectedItem">
      <div class="product-amount-selection" >
        <button class="button-minus ml-1 pl-1 pr-2 pt-n1 pb-2 " v-on:click="minus()">-</button>

          <div class="text-center text-bold ml-1 mr-1">
            {{getSelectedItem.count }}
          </div>        
        <button class="button-plus mr-0 pl-1 pr-2 pb-2" v-on:click="plus()">+</button>
     
        <div style="flex-grow: 2; padding-top:2px; margin-left: 5px;" v-html="getSelectedItem.priceInfo"></div>
        
        <div style="flex-grow: 0; padding-top:2px;">
          {{ getTotalSum().toFixed(2) }} EUR
        </div>
      </div>

  </div>
</template>

<script>
export default {
  name: "ShopVoucherServiceFixedPrice",
  props: ["getSelectedItemId"],
  methods: {
    plus() {
      if(this.getSelectedItem.maximumCount > this.getSelectedItem.count){
        this.getSelectedItem.count++;
      }else{
        console.log('Max Count reached!');
        
      }
      
    },
    minus() {
      if (this.getSelectedItem.count > 1) {
        this.getSelectedItem.count--;
      }
    },
    getTotalSum: function() {
      return (
        this.getSelectedItem.count * this.getSelectedItem.fixedPrice.toFixed(2)
      );
    },
    getCachedItem() {
      return this.$store.getters.getCachedItemById(this.getSelectedItemId);
    }
  },
  computed: {
    getSelectedLanguage() {
      return this.$store.getters.getLanguage;
    },
    getLanguageItem: function() {
      return this.$store.getters.getLanguageStrings;
    },
    getServices() {
      //console.log(this.getSelectedItem.type);
      return this.getSelectedItem.fixedPrice;
    },
    getSelectedItem() {
      return this.getCachedItem();
    }
  },
  beforeMount() {
    this.getSelectedItem.count = 1;
  }
};
</script>

